import React, { useState } from 'react';
import { Header } from '../../components';
import Layout from '../layout/Layout';
import * as Yup from 'yup';


import Button from '../../components/forms/components/Button/Button';
import FormField from '../../components/forms/components/FormField/FormField';
import FormSelect from '../../components/forms/components/FormSelect/FormSelect';
import Form from '../../components/forms/components/Form/Form';

import BeatLoader from "react-spinners/BeatLoader";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { ToastContainer, toast } from 'react-toastify';

import { createBoUser } from '../../services/users';

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required().label('Email'),
  role: Yup.string().required().label('Role')
});

const override = {
  textAlign: 'center',
  marginTop: '20px'
};

const CreateUser = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail]  = useState('');
  const [role, setRole] = useState('ADMIN');

  const signUpError = (error) => { 
    toast.error("Failed To Create User", {
      pauseOnHover: false,
      closeOnClick: true,
    })
  }
  // ConfigurationAlertType
  const signUpSuccess = (message) => {
    toast.success("User Created Successfuly", {
      pauseOnHover: false,
      closeOnClick: true,
    })
  }

  const setLoading = (loading) => {
    setIsLoading(loading);
  }

  const createUser = (values, {setSubmitting, setErrors, setStatus, resetForm}) => {

    createBoUser({email: values.email, password: 'Testing12345', role: values.role, setLoading: setLoading, signUpError: signUpError, signUpSuccess: signUpSuccess})
    setSubmitting(false);
    resetForm({
        values: { 
            email:  '',
            role: 'ADMIN'
      }
    });
  }

  return (
    <Layout>
    <div className="m-2 md:m-10 mt-24 md:p-5 ">
      <div className="w-[85%] mx-auto  p-3 md:p-5 bg-white rounded">
        
        <p>Create Back Office User - { isLoading }</p>
        <br />
        <Form 
        initialValues={{
          email: 'test@test.com',
          role: 'ADMIN'
        }}
        validationSchema={validationSchema}
        onSubmit={createUser}
        >
          <FormField name="email" placeholder="Enter Email" type="email"/>
          <FormSelect name="role"> 
            <option value="ADMIN">Admin</option>
            <option value="SUPERADMIN">Super Admin</option>
            <option value="AGENT">Agent</option>
          </FormSelect>
          <BeatLoader
          color="#36d7b7" 
          loading={isLoading}
          cssOverride={override}
        />
          <Button 
            title="CREATE USER"
            />
        </Form>
      </div>

    </div>
    </Layout>
  );
};
export default CreateUser;
